import ptBr from '@/locales/ptBr.json'
import en from '@/locales/en.json'

const dictionary = {
  en,
  ptBr
}

function getValue(keys, object) {
  if (!object || typeof object !== 'object' || keys.length === 0)
    return ''
  else if (keys.length === 1) {
    return object[keys[0]] || keys[0]
  } else {
    const key = keys[0]
    keys.splice(0, 1)
    return getValue(keys, object[key])
  }
}

export function Translate(message, { locale = 'ptBr'  }={}) {
  const translate = dictionary[locale]
  if (!translate || !message)
    return ''

  const keys = message.split('.')
  return getValue(keys, translate)
}